const hexRegex = /^#[0-9a-fA-F]{6}$/;

const isHex = (color: string): boolean => hexRegex.test(color);

const hexWithOpacity = (color: string, alpha: number): string => {
  const isAlphaValid = alpha >= 0 && alpha <= 1;
  const opacity = isAlphaValid ? alpha : 1;

  if (!isHex(color)) return 'rgb(0,0,0,1)';

  const r = `0x${color[1]}${color[2]}`;
  const g = `0x${color[3]}${color[4]}`;
  const b = `0x${color[5]}${color[6]}`;

  return `rgb(${+r},${+g},${+b},${opacity})`;
};

export default hexWithOpacity;
